import {
    BIKE_HISTORY_LOADING,
    BIKE_HISTORY_ERROR,

    BIKE_HISTORY_LIST,
    BIKE_HISTORY_FILTERS
} from "actions/bike-history/constants";

const initialState = {
    loading: false,
    errors: [],

    count: [],
    list: [],
    filters: [],
};

export default function(state = initialState, action) {
    switch (action.type) {
        case BIKE_HISTORY_LOADING:
            return {
                ...state,
                loading: action.payload.content
            };
        case BIKE_HISTORY_ERROR:
            return {
                ...state,
                loading: false,
                errors: action.payload.content
            };
        case BIKE_HISTORY_LIST:
            return {
                ...state,
                loading: false,
                errors: [],
                list: action.payload,
            };
        case BIKE_HISTORY_FILTERS:
            return {
                ...state,
                loading: false,
                errors: [],
                filters: action.payload.content,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/bikeHistoryReducer.js